import styled from 'styled-components';

export const SectionCareers = styled.div`
  padding: 50px 0;
  background-color: #f7f7f7;
  margin-top: 3rem !important;
`;

export const ArticleCareers = styled.div`
  display: flex;
  max-width: 768px;
  margin: 0 auto;
  padding: 50px 0;

  @media (max-width: 767.98px) {
    padding: 0 0;
    flex-flow: column;
  }
`;

export const ArticleImage = styled.div`
  min-width: 300px;
  vertical-align: middle;

  @media (max-width: 767.98px) {
    min-width: unset;
    width: 45%;
    margin: 0 auto 2rem;
  }
`;

export const ArticleText = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 100%;

  h3 {
    margin-bottom: 1.5rem;
    font-family: 'LibreBaskervilleRegular';

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
      margin-bottom: 1.5rem;
    }
  }

  p {
    color: #898989;
    margin-bottom: 1.5rem;
    margin-top: 0;
  }
  .tname {
    margin-bottom: 0;
    color: #333;
    span {
      color: #000;
      @media (max-width: 767.98px) {
        display: block;
      }
    }
  }
`;

export const SectionTwoBlock = styled.div`
  padding: 50px 0;

  &.bg_greycolumn {
    padding: 0;
    section[class*='VisitFeaturestyled__VisitFeature-'] {
      background: #f7f7f7;

      div[class*='Rowstyled__Row-'] {
        flex-direction: row-reverse;
      }
    }
  }
`;
